import { useSelector } from 'react-redux';
import { isRankingItemFetched } from '../types';
import { rankingSelector } from '../collectionRanking';
import { useCollectionProgress } from '../collectionProgress';
import { useTimer } from '../../../hooks';
import { getMillisUntilNextRefresh } from '../utils';
// return corrected ranking update timestamp or undefined if the ranking is final
// (updated after collectionEnd)
var getNextUpdateTimestamp = function (lastRankingUpdate, nextEstimatedRankingUpdate, collectionEndDate) {
    var collectionEndDateTimestamp = Number(new Date(collectionEndDate));
    if (lastRankingUpdate >= collectionEndDateTimestamp) {
        return undefined;
    }
    var msUntilNextUpdate = getMillisUntilNextRefresh(nextEstimatedRankingUpdate);
    return Date.now() + msUntilNextUpdate;
};
function useCollectionRankingTimer(collectionIdOrAlias) {
    var ranking = useSelector(function (state) {
        return rankingSelector(state, collectionIdOrAlias);
    });
    var collectionProgress = useCollectionProgress(collectionIdOrAlias);
    var nextEstimatedUpdateTimestamp = ranking && isRankingItemFetched(ranking) && collectionProgress
        ? getNextUpdateTimestamp(ranking.updatedAt, ranking.nextRefreshEstimate, collectionProgress.collection.availableUntil)
        : undefined;
    var timer = useTimer(nextEstimatedUpdateTimestamp !== null && nextEstimatedUpdateTimestamp !== void 0 ? nextEstimatedUpdateTimestamp : 0);
    // ranking/collection have not been fetched yet
    if (!ranking || !isRankingItemFetched(ranking) || !collectionProgress) {
        return undefined;
    }
    // collection has ended
    if (nextEstimatedUpdateTimestamp === undefined) {
        return {
            timer: timer,
            isCollectionEnded: true,
            lastUpdatedTimestamp: ranking.updatedAt,
        };
    }
    // collection is active, there will be a next ranking update
    return {
        timer: timer,
        isCollectionEnded: false,
        lastUpdatedTimestamp: ranking.updatedAt,
    };
}
export default useCollectionRankingTimer;
